/* SOFS bundle qty — el carrito no puede editar la línea fusionada del Cart Transform.
   "+" re-agrega el mismo pack (sube cantidad y precio). "−"/Eliminar quita el pack.
   Listener delegado en document (capture) para que funcione con el drawer renderizado por AJAX. */
(function () {
  if (window.__sofsBundleQtyBound) return;
  window.__sofsBundleQtyBound = true;

  var VAR = {
    "White": {"S":44434686378035,"M":44434686410803,"L":44434686443571,"XL":44434686476339,"XXL":44434686607411},
    "Dark Grey": {"S":44434686935091,"M":44434686967859,"L":44434687000627,"XL":44434687033395,"XXL":44434687066163},
    "Black": {"S":44434686672947,"M":44434686705715,"L":44434686738483,"XL":44434686771251,"XXL":44434686804019},
    "Navy Blue": {"S":44434687164467,"M":44434687197235,"L":44434687230003,"XL":44434687262771,"XXL":44434687295539},
    "Sand": {"S":44434687328307,"M":44434687361075,"L":44434687393843,"XL":44434687426611,"XXL":44434687459379}
  };
  var PACK_BY_COUNT = {1:"one",2:"two",3:"tree",5:"five"};

  function refresh() {
    var ce = document.querySelector('cart-element');
    if (ce && ce.getCart) { try { ce.getCart(); } catch (e) {} }
    else { try { location.reload(); } catch (e) {} }
  }

  // Cada pack es una línea separada (_grp único en la Function) → se quita por su key.
  function removeLine(key) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(refresh);
  }

  function readd(key) {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var it = cart.items.filter(function (i) { return i.key === key; })[0];
      if (!it) return;
      var props = it.properties || {};
      var keys = Object.keys(props).filter(function (k) { return k.indexOf('Camiseta') === 0; });
      var packKey = PACK_BY_COUNT[keys.length] || 'tree';
      var group = 'pkreadd_' + (window.performance ? Math.round(performance.now()) : 0) + '_' + keys.length;
      var items = [], idx = 0;
      keys.forEach(function (k) {
        idx++;
        var val = String(props[k] || '');
        var parts = val.split('/');
        var color = (parts[0] || '').trim();
        var size = (parts[1] || '').trim();
        var vid = (VAR[color] || {})[size];
        if (!vid) return;
        var img = props['_img_' + k.replace('Camiseta', '').trim()] || '';
        items.push({ id: Number(vid), quantity: 1, properties: {
          '_sofs_pack': packKey, '_sofs_pack_id': group, '_sofs_idx': String(idx),
          '_sofs_sel': val, '_sofs_img': img
        }});
      });
      if (!items.length) return;
      return fetch('/cart/add.js', {
        method: 'POST', headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({ items: items })
      }).then(refresh);
    });
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var item = e.target.closest('[data-sofs-bundle]');
    if (!item) return;
    var isRemove = e.target.closest('[data-item-remove]');
    var isMinus = e.target.closest('[data-quantity-minus]');
    var isPlus = e.target.closest('[data-quantity-plus]');
    if (!isRemove && !isMinus && !isPlus) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var key = item.getAttribute('data-item');
    if (isPlus) { readd(key); } else { removeLine(key); }
  }, true);
})();
